
<template>
<div>
  <oci-session-modal
    v-if="displaySessionMessage && showSessionDialog"
    v-on:ok="continueSession"
    v-on:cancel="destroySession"
    v-on:hide="hideModal"
    v-on:counterComplete="countdownComplete"
    v-on:credentials="captureCredentials"
    :type="dialog.type"
    :text="dialog.message"
    :title="dialog.title"
    :counter="dialog.inactivityCounter"
    :okText="dialog.okText"
    :cancelText="dialog.cancelText"

  >
  </oci-session-modal>
</div>
</template>

<script>
  import OciSessionModal from '@/common/components/OciSessionModal.vue'
    export default {
        name: "OciSessionManagement",
      data() {
        return {
          inactivityTimer: null,
         showSessionDialog: false,
          userInactive:false,
          sessionChecker:null,
           //tokenMinimumTime:600,//Seconds minimum time before asking user to refresh token - 10 mins
          tokenMinimumTime:60*20, //20 minutes left to token Expiration minimum
           dialog:{
            message:"",
            type:"",
            title:"",
            okText:"",
            cancelText:"",
            inactivityCounter: 0,
          },
          authRequest:{
            userName:"",
            password:""
          },
          defaultInactivityTime:0,
          defaultInactivityCounter:0
        }
      },
      components:{
        OciSessionModal
      },
      computed:{
        displaySessionMessage(){
           if(this.$store.getters.sessionInfo){
            let sessionInfo = this.$store.getters.sessionInfo;
            // check if token time before expiring is less than tokenMinimumTime and user can still refresh.
            if(sessionInfo.tte<this.tokenMinimumTime && sessionInfo.ref===true){
              this.dialog.inactivityCounter=sessionInfo.tte;
              this.setExtendPromptData();
            }
            // check if token time before expiring is less than tokenMinimumTime and user has to login due to more refresh options
            else if (sessionInfo.tte<this.tokenMinimumTime && sessionInfo.ref===false){
              this.dialog.inactivityCounter=sessionInfo.tte;
              this.setLoginPromptData();
            }
            else if(this.userInactive ){
              this.dialog.inactivityCounter=60*this.defaultInactivityCounter;
              this.setInactivePromptData()
            }
            else {
              this.showSessionDialog=false;
            }
             }
          return this.showSessionDialog
        },
      },
      methods:{
        setInactivePromptData(){
          this.dialog.title="User Inactivity";
          this.dialog.type="inactive";
          this.dialog.message="Continue with your session?";
          this.dialog.okText="Continue";
          this.dialog.cancelText="Sign-out";
          this.showSessionDialog=true;
        },
        setExtendPromptData(){
          this.dialog.title="Session Timeout";
          this.dialog.type="extend";
          this.dialog.message="Continue with your session?";
          this.dialog.okText="Continue";
          this.dialog.cancelText="Sign-out";
          this.showSessionDialog=true;
        },
        setLoginPromptData(){
          this.dialog.type="login";
          this.dialog.title="Login Required"
          this.dialog.message="Your session is about to expire, type in your OneClose password to extend:";
          this.dialog.okText="Login";
          this.dialog.cancelText="Sign-out";
          this.showSessionDialog=true;
        },

        trackInactivity() {
          window.addEventListener("mousemove", this.resetInactivityTimer, false);
          window.addEventListener("mousedown", this.resetInactivityTimer, false);
          window.addEventListener("keypress", this.resetInactivityTimer, false);
          window.addEventListener("DOMMouseScroll", this.resetInactivityTimer, false);
          window.addEventListener("mousewheel", this.resetInactivityTimer, false);
          window.addEventListener("touchmove", this.resetInactivityTimer, false);
          window.addEventListener("MSPointerMove", this.resetInactivityTimer, false);
          this.startTimer();
        },
        startTimer() {
          // wait 5 seconds before calling goInactive
          this.inactivityTimer = window.setTimeout(() => {
            this.goInactive();
          }, 1000*60*this.defaultInactivityTime); //it checks in milliseconds
        },
        goInactive() {
          if(this.dialog.type!=="inactive"){
            this.userInactive=true;
          }
        },
        captureCredentials(credentials){
        this.authRequest.userName = credentials.userName;
        this.authRequest.password = credentials.password;
               },
        continueSession(){
          //decide what to do with clicking ok button
          // tiggered by userInactivity on frontend
          switch(this.dialog.type){
            case "inactive":
              this.showSessionDialog=false;
              break;
            case "extend":
              this.$store.dispatch('refreshToken');
              this.showSessionDialog=false;
              break;
            case "login":
             this.$store.dispatch('sendLoginCredentials',this.authRequest);
              this.showSessionDialog=false;
              break;
          }
          this.clearDialogValues();
        },
        destroySession(){
          this.signOut();
        },
        goActive() {
          //console.log("goActive")
          this.startTimer();
        },
        resetInactivityTimer() {
          //console.log("Reset Activity")
          window.clearTimeout(this.inactivityTimer);
          this.goActive();
        },
        hideModal(){
          this.showSessionDialog=false;
        },
        checkSessionInfo(){
          this.sessionChecker = window.setInterval(()=>{this.$store.dispatch('sessionInfoCheck')},(1000*60*1)) //run every minute
        },
        signOut(){
          this.$store.dispatch("revokeToken");
          window.location.replace('/auth/login');
            },
        countdownComplete(){
          this.signOut();
        },
        clearDialogValues(){
          this.userInactive=false;
          this.dialog.type="";
          this.dialog.title=""
          this.dialog.message="";
          this.dialog.okText="";
          this.dialog.cancelText="";
        },
        setDefaultSessionInfo(){
          let env = process.env.NODE_ENV
          if(env==="dev"){
            this.defaultInactivityTime= 30
            this.defaultInactivityCounter=10
          }
          else if (env==='staging'){
            this.defaultInactivityTime= 30
            this.defaultInactivityCounter=10
          }
          else {
            this.defaultInactivityTime= 5
            this.defaultInactivityCounter=10
          }
        }

      },
      mounted(){
        this.setDefaultSessionInfo();
        this.trackInactivity();
        this.checkSessionInfo();
      }

    }
</script>

<style scoped>

</style>
